/* Mystery Box TermoHub - logica global (carga en todas las paginas).
   Umbral: $1,500 MXN = 150000 centavos (precio antes de descuentos).
   Variante del producto Mystery Box: 52524294209821 */
(function () {
  if (window.__thtMBBound) return;
  window.__thtMBBound = true;
  var VID = 52524294209821;
  var THRESHOLD = 150000;
  var syncing = false;

  function cartTotalForMB(cart) {
    return (typeof cart.original_total_price === 'number') ? cart.original_total_price : cart.total_price;
  }

  function getImg() {
    var im = document.querySelector('.mb-modal__media img');
    return im ? im.src : null;
  }

  function dialogFor(el) {
    var bar = el && el.closest ? el.closest('.mb-bar') : null;
    if (bar && bar.nextElementSibling && bar.nextElementSibling.hasAttribute && bar.nextElementSibling.hasAttribute('data-mb-modal')) {
      return bar.nextElementSibling;
    }
    var all = document.querySelectorAll('[data-mb-modal]');
    for (var i = 0; i < all.length; i++) {
      var drawer = all[i].closest('dialog.cart-drawer__dialog');
      if (!drawer || drawer.open) return all[i];
    }
    return all.length ? all[0] : null;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-mb-open]')) {
      var d = dialogFor(e.target);
      if (d && !d.open) d.showModal();
      return;
    }
    if (e.target.closest('[data-mb-close]')) {
      var d2 = e.target.closest('[data-mb-modal]');
      if (d2 && d2.open) d2.close();
      return;
    }
    if (e.target.matches && e.target.matches('dialog[data-mb-modal]') && e.target.open) {
      e.target.close();
      return;
    }
    var addBtn = e.target.closest('[data-mb-add]');
    if (!addBtn) return;
    e.preventDefault();
    if (addBtn.getAttribute('data-loading') === '1') return;
    addBtn.setAttribute('data-loading', '1');
    addBtn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: VID, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) {
          if (r.status === 429) {
            throw new Error('Shopify bloqueo los intentos repetidos por unos minutos. Espera un poco y vuelve a intentar.');
          }
          return r.json().then(function (j) {
            throw new Error((j && (j.description || j.message)) || 'Intenta de nuevo');
          });
        }
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var d3 = addBtn.closest('[data-mb-modal]');
        if (d3 && d3.open) d3.close();
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'tht-mb', data: { source: 'tht-mb', itemCount: cart.item_count } }
        }));
      })
      .catch(function (err) {
        alert('Mystery Box: ' + (err && err.message ? err.message : 'intenta de nuevo'));
      })
      .finally(function () { addBtn.removeAttribute('data-loading'); addBtn.classList.remove('is-loading'); });
  });

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  function mbSync(cart) {
    if (syncing) return;
    var line = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === VID) { line = cart.items[i]; break; }
    }
    if (!line) return;
    var needRemove = cartTotalForMB(cart) < THRESHOLD;
    var needClamp = line.quantity > 1;
    if (!needRemove && !needClamp) return;
    syncing = true;
    changeLine(line.key, needRemove ? 0 : 1)
      .then(function (r) { if (!r.ok) throw new Error('change'); return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart2) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart2, sourceId: 'tht-mb-sync', data: { source: 'tht-mb-sync', itemCount: cart2.item_count } }
        }));
      })
      .catch(function () {})
      .finally(function () { syncing = false; });
  }

  function mbThumbs() {
    var img = getImg();
    if (!img) return;
    var rows = document.querySelectorAll('[data-key^="' + VID + '"] .cart-items__media');
    for (var i = 0; i < rows.length; i++) {
      if (!rows[i].querySelector('img')) {
        rows[i].innerHTML = '<div class="cart-items__media-container mb-thumb" style="--ratio:1;"><img class="cart-items__media-image" src="' + img + '" alt="Mystery Box" width="250" height="250"></div>';
      }
    }
  }

  document.addEventListener('cart:update', function (e) {
    var src = e && e.detail && (e.detail.sourceId || (e.detail.data && e.detail.data.source));
    setTimeout(mbThumbs, 350);
    if (src === 'tht-mb-sync') return;
    var cart = e && e.detail && e.detail.resource;
    if (cart && cart.items) {
      mbSync(cart);
    } else {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(mbSync)
        .catch(function () {});
    }
  });

  var mo = new MutationObserver(function () {
    if (window.__thtMBRaf) return;
    window.__thtMBRaf = requestAnimationFrame(function () {
      window.__thtMBRaf = null;
      mbThumbs();
    });
  });
  function startObserver() {
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
    mbThumbs();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
